import { notification } from 'onsenui'

export function downloadFile(url, filename, callback = null) {
    return _download(url, filename, true, callback)
}

export function downloadFileImmediate(url, filename, callback = null) {
    return _download(url, filename, false, callback)
}

export function base64toBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.substr(b64Data.indexOf(',') + 1)
    const byteCharacters = atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
    }

    return new Blob(byteArrays, { type: contentType })
}

export function _download(url, filename, enableConfirm = false, callback = null) {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'

    xhr.onprogress = function(event) {
        if (event.lengthComputable) {
            var percentComplete = (event.loaded / event.total) * 100
        }
    }

    xhr.onload = function(event) {
        //status 206 for firefox
        if (this != undefined && this['status'] != undefined && (this['status'] == 200 || this['status'] == 206)) {

            saveBlob(this['response'], filename, enableConfirm)
            if (typeof callback === 'function') {
                callback()
            }
        }
    }

    xhr.onerror = function(err) {
        console.error('** An error occurred during the transaction')
    }

    xhr.send()
}

export function openConfirm(confirmCallback, title = null, message = null, buttonLabel = null) {
    message = message || 'Click to download file.'
    title = title || 'Download'
    buttonLabel = buttonLabel || 'OK'

    notification.confirm({
        message: message,
        title: '<b> ' + title + '</b>',
        buttonLabels: [buttonLabel],
        callback: i => {
            if (i === 0) {  // here this is not cancelled.  1 is correct.
                if (typeof confirmCallback === 'function') {
                    confirmCallback()
                }
            }
        },
    })
}

export function saveBlob(blob, fileName, enableConfirm = false) {
    if (navigator.msSaveBlob) {
        //OK for IE10+
        navigator.msSaveBlob(blob, fileName)
    } else {
        _html5Saver(blob, fileName, enableConfirm)
    }
}

export function _html5Saver(blob, fileName, enableConfirm = false) {
    const aElement = document.createElement('a')
    aElement.style.display = 'none'
    document.body.appendChild(aElement)
    const url = window.URL.createObjectURL(blob)

    aElement.setAttribute('href', url)
    aElement.setAttribute('download', fileName)
    if (enableConfirm) {
        openConfirm(() => {
            aElement.click()
            aElement.remove()
        })
    } else {
        aElement.click()
        aElement.remove()
    }
}



// WEBPACK FOOTER //
// ./src/helper/download.helper.ts